import styled from 'styled-components';

import { styledScroll } from 'styles/styledScroll';

import colors from 'themes/Main';

const { white, gray02, gray03 } = colors;

export const Container = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  z-index: 50;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
`;

export const Modal = styled.div`
  overflow-y: auto;
  position: relative;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
  width: ${({ modalWidth }) => `${modalWidth}px`};
  max-height: 600px;
  padding: 32px;
  border-radius: 10px;
  background-color: ${white};
  box-shadow: 0px 7px 8px rgba(0, 0, 0, 0.2), 0px 5px 22px rgba(0, 0, 0, 0.12),
    0px 12px 17px rgba(0, 0, 0, 0.14);
  ${styledScroll};
`;

export const CloseModal = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  outline: none;
  background: transparent;
  border: 0;
  font-size: 20px;
  font-weight: 700;
  color: ${gray03};

  &:hover {
    transition: color 300ms ease-in-out;
    color: ${gray02};
  }
`;

export const Content = styled.div`
  margin-top: 32px;
`;
